/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-18 15:33:43
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-12 13:57:55
 */

import { createPinia } from 'pinia'
import settings from './setting'
import cachedView from './cachedView'

const pinia = createPinia()
export default pinia

const context = import.meta.glob('../../modules/**/pinia/*.js', { eager: true })
let modulesPinias = {
  settings,
  cachedView
}
Object.keys(context).forEach((key) => {
  const [path, module, base, fileName] = key.replace(/(\..\/|\/module\/|\.js)/g, '').split('/')
  const tempObj = {}
  tempObj[fileName] = context[key].default
  modulesPinias = { ...modulesPinias, ...tempObj }
})

export const pinias = {
  ...modulesPinias
}
